import React, { useState } from 'react';

import { faAngleDown } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';

import { FontAwesomeSvgIcon } from 'components/shared';

import { TabType } from '../../BaseTabsRouting';
import { MenuItems } from './MenuItems';

type Props = {
  tabbedElement: TabType;
  tabulatedItems: TabType[];
  setTabbedElement;
  page: string;
};

const SwitcherComponent = ({
  tabulatedItems,
  tabbedElement,
  setTabbedElement,
  page
}: Props) => {
  const { t } = useTranslation('common');

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
      <Button
        variant="contained"
        color="lightGray"
        sx={{
          px: '14px',
          height: '40px',
          border: '1px solid #EFEFEF'
        }}
        onClick={handleClick}
        endIcon={<FontAwesomeSvgIcon icon={faAngleDown} sx={{ ml: 1 }} />}
      >
        {t(`tableTabs.${tabbedElement.name}`)}
      </Button>
      <MenuItems
        open={open}
        componentName={tabbedElement.name}
        handleClose={handleClose}
        tabulatedItems={tabulatedItems}
        anchorEl={anchorEl}
        setTabbedElement={setTabbedElement}
        page={page}
      />
    </div>
  );
};

export default SwitcherComponent;
